export default __webpack_public_path__ + "static/media/WM0380.34I-43156_-25814_0.9877575b.jpg";